import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=male&exp=web_fallback_on_payment_male_row~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_row/web_fallback_on_payment_male_row__male'
					),
			},
		},
		'activity-male-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=activity-male-walking&exp=web_fallback_on_payment_male_row~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_row/web_fallback_on_payment_male_row__male_walking'
					),
			},
		},
		'activity-male-tai-chi-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=activity-male-tai-chi-yoga&exp=web_fallback_on_payment_male_row~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_row/web_fallback_on_payment_male_row__male_tai_chi_yoga'
					),
			},
		},
		'activity-male-chair-workouts': {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=activity-male-chair-workouts&exp=web_fallback_on_payment_male_row~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_row/web_fallback_on_payment_male_row__male_chair_workouts'
					),
			},
		},
	},
]

export default config
